/* ============================================================
   TrueNooch Marketing Site — App shell
   ============================================================
   Responsibilities:
   - Firebase init bootstrap
   - Mount the router and hand off to MarketingSite

   There are no auth-gated routes. The blog / R&D Lab / CMS were removed
   on 2026-08-30: Firebase Hosting has no server-side auth, so the old
   AuthGate only gated rendering, never access — anything imported into
   React shipped inside main.*.js to every visitor. Marketing content is
   the only thing this bundle should carry. If internal tooling comes
   back it belongs behind firestore.rules, not in public/ or the bundle.
   ============================================================ */

import React, { useState, useEffect } from 'react';
import './App.css';
import { initFirebase, FirebaseInstances } from './firebase';
import { BrowserRouter } from 'react-router-dom';
import { MarketingSite } from './components/MarketingSite';

function App() {
  const [fb, setFb] = useState<FirebaseInstances | null>(null);

  useEffect(() => {
    initFirebase()
      .then(setFb)
      .catch((err) => {
        // Non-fatal: the marketing site renders without Firebase; only the
        // waitlist and club forms need `db`.
        console.error('Firebase init failed:', err);
      });
  }, []);

  return (
    <BrowserRouter>
      <MarketingSite db={fb?.db ?? null} />
    </BrowserRouter>
  );
}

export default App;
